import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import { Colors } from '../../theme'

export const SupportButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'onDark',
})(({ onDark }) => ({
  color: onDark ? Colors.WHITE : Colors.BG_START,
  fontSize: '0.9rem',
  fontWeight: 'bold',
  textTransform: 'none',
}))
